import { isAxiosError } from "axios";
import { type BaseResponse } from "../lib/api-contract";

export const getErrorMessage = (error: unknown, defaultMessageError?: string) => {
    if (isAxiosError<BaseResponse<unknown>, unknown>(error)) {
        return error.response?.data?.message || error?.message;
    }
    return defaultMessageError || 'An error occurred';
}
